import { WifiOff } from "lucide-react";

/**
 * Estado "sin conexión" para una vista.
 *  - variant "block" (default): reemplaza el contenido cuando no hay datos ni
 *    cache (en vez de un skeleton infinito).
 *  - variant "banner": aviso compacto arriba de la tabla cuando SÍ hay datos
 *    cacheados que se están sirviendo offline.
 */
export default function OfflineDataNotice({
  title = "Sin conexión",
  description = "Estos datos no están disponibles sin conexión. Se cargarán cuando vuelva la red.",
  variant = "block",
  className,
}: {
  title?: string;
  description?: string;
  variant?: "block" | "banner";
  className?: string;
}) {
  if (variant === "banner") {
    return (
      <div
        className={
          "flex items-center gap-2 rounded-md border border-dashed border-amber-400/50 bg-amber-50/50 px-3 py-1.5 text-xs text-amber-700 dark:bg-amber-950/20 dark:text-amber-400 " +
          (className ?? "")
        }
      >
        <WifiOff className="size-3.5 shrink-0" />
        <span>{title}</span>
      </div>
    );
  }

  return (
    <div
      className={
        "flex flex-col items-center justify-center gap-2 rounded-lg border border-dashed border-border bg-muted/20 px-6 py-12 text-center " +
        (className ?? "")
      }
    >
      <WifiOff className="size-8 text-muted-foreground/50" />
      <p className="text-sm font-medium text-foreground">{title}</p>
      <p className="max-w-sm text-xs text-muted-foreground">{description}</p>
    </div>
  );
}
